<div
    class="tw-py-[50px] tw-px-[28px] md:tw-px-[50px] lg:tw-px-[80px] tw-bg-[#024B3F0A]"
>
    <!-- Grid for loop over products -->
    <div
        class="tw-grid lg:tw-grid-cols-3 md:tw-grid-cols-2 tw-grid-cols-1 lg:tw-gap-6 md:tw-gap-[43px] tw-gap-[25px] tw-items-stretch"
    >
        <div
            *ngFor="let product of filteredCards | slice : 0 : visibleCount"
            class="tw-h-full"
        >
            <app-card-type-4
                [gaPrefix]="gaPrefix"
                [image]="product.image"
                [title]="product.title"
                [subtitle]="product.subtitle"
                [description]="product.description"
                [buttonText]="product.buttonText"
                (buttonClick)="openLink(product.productUrl)"
            ></app-card-type-4>
        </div>
    </div>
    <!-- Show More Button -->
    <div
        class="tw-flex tw-justify-center tw-mt-8"
        *ngIf="visibleCount < filteredCards.length"
    >
        <button
            [attr.ga-event-id]="
                'multisectoral_green_certification_show_more_button_jc3_click'
            "
            [attr.ga-event-category]="'JC3 Button'"
            [attr.ga-event-label]="
                'Multi-sectoral Green Certifications - Show More Button Click'
            "
            ga-track="track"
            class="tw-bg-white tw-border tw-border-[#024B3F] tw-text-[#024B3F] tw-text-[14px] tw-font-bold tw-px-[23px] tw-py-[12px] tw-rounded-full tw-flex tw-items-center tw-justify-center tw-w-[188px] tw-gap-2 hover:tw-bg-[#024B3F] hover:tw-text-white transition"
            (click)="showMore()"
        >
            Show more
            <!-- Down Arrow Icon -->
            <svg
                xmlns="http://www.w3.org/2000/svg"
                class="tw-w-4 tw-h-4"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
            >
                <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M19 9l-7 7-7-7"
                />
            </svg>
        </button>
    </div>
</div>
